import React from 'react'
import Dinero from 'dinero.js'
import {useNavigate} from 'react-router'
import PropTypes from 'prop-types'
import {Box, Flex, Text, Button} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'

const PendingCircle = () => (
  <Flex
    shadow="lg"
    borderRadius="full"
    width="190px"
    height="190px"
    bg="mld.neutral.50"
    justify="center"
    align="center"
    gap="xs"
  >
    <Box
      role="presentation"
      borderRadius="full"
      width="40px"
      height="40px"
      bg="radial-gradient(64.67% 64.67% at 64% 35.33%, #F75217 0%, #F75217 0.01%, #FF8E3C 100%)"
    />
    <Box
      role="presentation"
      borderRadius="full"
      width="40px"
      height="40px"
      bg="radial-gradient(64.67% 64.67% at 64% 35.33%, #F75217 0%, #F75217 0.01%, #FF8E3C 100%)"
    />
    <Box
      role="presentation"
      borderRadius="full"
      width="40px"
      height="40px"
      bg="radial-gradient(64.67% 64.67% at 64% 35.33%, #F75217 0%, #F75217 0.01%, #FF8E3C 100%)"
    />
  </Flex>
)

export const SuccessScreen = ({paymentAmount}) => {
  const {t} = useTranslation('pointsOnPayment')
  const navigate = useNavigate()

  const goToBills = () => {
    navigate('/points_on_payments/bills')
  }

  const formattedAmount = Dinero({amount: paymentAmount}).toFormat()

  return (
    <Flex minH="calc(100vh - 65px)" justify="center" p="lg">
      <Flex
        borderRadius="lg"
        border="none"
        background="white"
        boxShadow="md"
        rounded="md"
        p="lg"
        direction="column"
        align="center"
        gap="md"
        height="fit-content"
      >
        <PendingCircle />
        <Text textAlign="center" textStyle="headline2">
          {t('pointsOnPayments:paymentWizard.successScreen.title')}
        </Text>
        <Text textAlign="center" textStyle="body-copy">
          {t('pointsOnPayments:paymentWizard.successScreen.subtitle', {
            amount: formattedAmount,
          })}
        </Text>

        <Button variant="secondary" onClick={goToBills}>
          {t('pointsOnPayments:paymentWizard.successScreen.billsLinkLabel')}
        </Button>
      </Flex>
    </Flex>
  )
}

SuccessScreen.propTypes = {
  paymentAmount: PropTypes.number.isRequired,
}
